export const STATUS_COLORS = {
    // Positive/complete statuses (Success - Green)
    'complete': '#2CA24B',
    'qualified': '#2CA24B',
    'approved': '#2CA24B',
    'passed': '#2CA24B',
  
  // Action required/open statuses (Info - Blue)
  'open': '#0065D0',
  'deferred': '#0065D0',
  
    // In progress statuses (Info - Blue)
    'in_progress': '#0065D0',
    'pending': '#D3180C', // Alert - Red
    'registered': '#0065D0',
    'attending': '#0065D0',
    'submitted': '#D3180C', // Alert - Red
    'in_review': '#D3180C', // Alert - Red
    'returned': '#D3180C', // Alert - Red
  
    // Ineligible status (Warning - Orange)
    'locked': '#CB6E00',
 
    // Negative/failed statuses (Alert - Red)
    'denied': '#D3180C',
    'failed': '#D3180C',
    'expired': '#D3180C',

  
    // Default fallback (Default - Gray)
    'default': '#404446'
  }
  
  export const STATUS_BACKGROUND_COLORS = {
    // Positive/complete statuses (Success - Light Green)
    'complete': '#F0FFF4',
    'qualified': '#F0FFF4',
    'approved': '#F0FFF4',
    'passed': '#F0FFF4',
  
  // Action required/open statuses (Info - Light Blue)
  'open': '#E3F5FB',
  'deferred': '#E3F5FB',
  
    // In progress statuses (Info - Light Blue)
    'in_progress': '#E3F5FB',
    'pending': '#FFE5E5', // Alert - Light Red
    'registered': '#E3F5FB',
    'attending': '#E3F5FB',
    'submitted': '#FFE5E5', // Alert - Light Red
    'in_review': '#FFE5E5', // Alert - Light Red
    'returned': '#FFE5E5', // Alert - Light Red
  
    // Ineligible status (Warning - Light Orange)
    'locked': '#FFEFD7', 
  
    // Negative/failed statuses (Alert - Light Red)
    'denied': '#FFE5E5',
    'failed': '#FFE5E5',
    'expired': '#FFE5E5',
  
    // Default fallback (Default - Light Gray)
    'default': '#E9EEF2'
  }
  